import { render, staticRenderFns } from "./BreakoutRoomsEditor.vue?vue&type=template&id=54acf4da&scoped=true"
import script from "./BreakoutRoomsEditor.vue?vue&type=script&lang=js"
export * from "./BreakoutRoomsEditor.vue?vue&type=script&lang=js"
import style0 from "./BreakoutRoomsEditor.vue?vue&type=style&index=0&id=54acf4da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54acf4da",
  null
  
)

export default component.exports